import { render, staticRenderFns } from "./MaterialChartCard2.vue?vue&type=template&id=398ece5c&"
import script from "./MaterialChartCard2.vue?vue&type=script&lang=js&"
export * from "./MaterialChartCard2.vue?vue&type=script&lang=js&"
import style0 from "./MaterialChartCard2.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports